import script from "./HostingTable.vue?vue&type=script&lang=js"
export * from "./HostingTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__